import { useGridApiContext7 } from "../../platform-style";
import { useRef } from "react";

/**
 * @deprecated Use useGridApiContext7 instead.
 */
export const useGridApiContext = () => {
  const ref = useRef();
  const apiRef = useGridApiContext7();

  const setFilterModel = (model: any) => {
    // @ts-ignore
    const items = model.items.map((filter) => {
      return {
        id: filter.id,
        // @ts-ignore
        value: filter.value,
        // @ts-ignore
        operator: filter.operatorValue,
        // @ts-ignore
        field: filter.columnField,
      };
    });

    // @ts-ignore
    apiRef.current.setFilterModel({ ...model, items: items });
  };

  // @ts-ignore
  ref.current = { ...apiRef.current, setFilterModel };

  return ref;
};
